<div class="products-container">
  <p-card header="Vérification de tournées" styleClass="products-card">
    <br />
    <!-- FILTRES -->
    <div class="flex flex-wrap gap-3 mb-3">
      <p-calendar
        [(ngModel)]="dateFrom"
        dateFormat="yy-mm-dd"
        placeholder="Date début"
        (onSelect)="applyFilters()"
        showIcon
      ></p-calendar>

      <p-calendar
        [(ngModel)]="dateTo"
        dateFormat="yy-mm-dd"
        placeholder="Date fin"
        (onSelect)="applyFilters()"
        showIcon
      ></p-calendar>

      <p-dropdown
        [options]="technicians"
        [(ngModel)]="selectedTechnician"
        optionLabel="name"
        optionValue="id"
        placeholder="Technicien"
        (onChange)="applyFilters()"
        [filter]="true"
        [filterPlaceholder]="'Rechercher technicien...'"
        [showClear]="true"
      ></p-dropdown>

      <p-selectButton
        [options]="optimizationStatusOptions"
        [(ngModel)]="optimizedOnly"
        (onChange)="applyFilters()"
        optionLabel="label"
        optionValue="value"
        ariaLabel="Filtrer optimisation"
      ></p-selectButton>

      <p-button
        label="Vérificateur de tournée"
        icon="pi pi-external-link"
        (onClick)="openTourChecker()"
        styleClass="p-button-outlined"
      ></p-button>
    </div>

    <!-- TABLE -->
    <p-table
      [value]="filteredResults"
      [paginator]="true"
      [rows]="rowsPerPage"
      [totalRecords]="totalRecords"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [sortField]="'distance_saved_km'"
      [sortOrder]="-1"
      styleClass="p-datatable-sm"
      [rowHover]="true"
      [style]="{ marginTop: '20px' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="technician">Technicien</th>
          <th pSortableColumn="analysis_date">Jour analysé</th>
          <th pSortableColumn="interventions_count">Interventions</th>
          <th pSortableColumn="distance_saved_km">
            Distance économisée (km)
            <p-sortIcon field="distance_saved_km"></p-sortIcon>
          </th>
          <th pSortableColumn="duration_saved_min">
            Temps économisé (min)
            <p-sortIcon field="duration_saved_min"></p-sortIcon>
          </th>
          <th>Optimisation</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-result>
        <tr (click)="goToCheck(result)" class="cursor-pointer">
          <td>{{ result.technician }}</td>
          <td>{{ result.date | date }}</td>
          <td>{{ result.interventionsCount }}</td>
          <td>
            {{ result.gain }} km
            <span
              *ngIf="result.distancePercentSaved > 0"
              class="text-xs text-500 ml-1"
            >
              ({{ result.distancePercentSaved }}%)
            </span>
          </td>
          <td>
            {{ result.timeSaved }} min
            <span
              *ngIf="result.timePercentSaved > 0"
              class="text-xs text-500 ml-1"
            >
              ({{ result.timePercentSaved }}%)
            </span>
          </td>
          <td>
            <p-tag *ngIf="result.isOptimized" severity="success">
              Optimisé
            </p-tag>
            <p-tag *ngIf="!result.isOptimized" severity="info">
              Déjà optimal
            </p-tag>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">
            <div class="flex flex-column align-items-center p-4">
              <i class="pi pi-calendar-minus text-4xl text-500 mb-2"></i>
              <h3 class="text-500">Aucun résultat d'optimisation</h3>
              <p class="text-500">Aucune tournée à vérifier pour le moment.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
